import { Col } from "antd";

export const Col_12_8_6_4 = ({ style, children }) => {
  return (
    <Col style={{ ...style }} xs={12} sm={8} md={6} lg={4}>
      {children}
    </Col>
  );
};
